var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 6.75v3m0 3h.008M7.962 2.92 1.793 13.574c-.342.59-.513.886-.488 1.129a.75.75 0 0 0 .305.529c.197.143.539.143 1.222.143h12.337c.683 0 1.024 0 1.221-.143a.75.75 0 0 0 .305-.53c.026-.242-.145-.537-.488-1.128L10.04 2.919c-.341-.589-.512-.883-.734-.982a.75.75 0 0 0-.61 0c-.222.099-.392.393-.733.982Z"
  })));
};
export default SvgAlertTriangle;